var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.4754 16.5973C13.4754 16.7946 13.5914 16.9734 13.7716 17.0538C13.9517 17.1343 14.1623 17.1013 14.3092 16.9695L21.3338 10.6709C21.4396 10.5761 21.5 10.4407 21.5 10.2986C21.5 10.1566 21.4396 10.0212 21.3338 9.92638L14.3092 3.62773C14.1623 3.49603 13.9517 3.46301 13.7716 3.54344C13.5914 3.62387 13.4754 3.80271 13.4754 4L13.4754 5.63797L13.4754 7.21088C11.347 7.30317 8.87465 7.99491 6.91548 9.74453C4.78432 11.6477 3.32816 14.742 3.51637 19.4744C3.52996 19.8162 3.79623 20.0058 4.01846 20.0456C4.24184 20.0855 4.56227 19.9982 4.6895 19.6744C5.53235 17.5295 8.10479 13.7009 13.4754 13.2338L13.4754 16.5973Z","strokeLinejoin":"round"}));
}

Share.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Share;

Share.default = Share;
